<template>
  <div class="player_wrap" :class="playBoxClass" id="player_wrap">
    <div
      :class="['player-box', 'player-box--layout' + windowNumber]"
      :style="{ '--layoutType': Math.sqrt(windowNumber) }"
    >
      <div
        :class="['player-box__item', 'wnd_' + wnd, hasActive(wnd), hasScreen(wnd)]"
        :ref="'wnd_' + wnd"
        v-for="wnd in maxWnd"
        :key="wnd"
        @click="handleClickWnd(wnd)"
        @dblclick="handleDblClickWnd(wnd)"
        v-show="wnd <= windowNumber"
      ></div>
    </div>
  </div>
</template>

<script>
import busVue from "@/common/utils/busVue";
export default {
  props: {
    // windowNumber: {
    //   type: Number,
    //   default: () => 4,
    // },
    playBoxClass: {
      type: String,
      default: "gateWay",
    },
    isAddBtn: {
      type: Boolean,
      default: false,
    },
    isHideClose: {
      type: Boolean,
      default: false,
    },
    isShowRightTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxWnd: 25,
      screenTypeList: [4, 6, 9, 13, 16, 25],
      showScreenTip: false,
      playPlugin: this.$store.getters.playInfo, //播放器信息
      playRecord: {}, //窗口消息集合：窗口序号：播放插件容器/id
      deviceRecord: {}, //窗口设备信息集合：窗口序号：设备信息
      AccessToken: "", //鉴权token
      windowNumber: 4, //窗口数量
      activeWnd: 1, //激活的窗口序号
      screenWnd: 0, ///放大的窗口序号
      isPlayState: 0, //窗口，插件初始化状态
      scenceCode: "",
    };
  },
  created() {
    // 接收busVue摄像机选中事件回调
    // this.handleLoginPlugin();
  },
  mounted() {
    // if (this.$store.getters.isInitPlay) {
    //   this.handleInitWnd();
    // } else {
    //   this.$app.AppInstance.handleInitPlay(() => {
    //     console.log("重新初始化成功");
    //     this.handleInitWnd();
    //   });
    // }
  },
  methods: {
    // 初始化窗口
    handleInitWnd() {
      let className = "." + this.playBoxClass + "> .player-box";
      let playBox = document.querySelector(className);
      // console.log(playBox);
      for (let i = 1; i <= this.maxWnd; i++) {
        let iframeObj = imosSdk.createPanelWindow();
        if (iframeObj === null) {
          return;
        }
        this.playRecord["wnd_" + i] = iframeObj;
        playBox.childNodes[i - 1].innerHTML = "";
        playBox.childNodes[i - 1].appendChild(iframeObj);
        this.isHideClose &&
          this.hiddenVideoBtn({
            wndKey: "wnd_" + i,
            videoItem: {
              type: 4,
              btnId: ["close"],
            },
          });
      }
    },
    // 隐藏btn
    hiddenVideoBtn(option) {
      let that = this;
      imosSdk.hiddenVideoBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.videoItem,
        function (res) {
          // console.log("隐藏按钮", res);
        }
      );
    },
    addBtn(id, data, btn) {
      imosSdk.addBottomBtn(
        id,
        {
          id: btn.id,
          className: btn.class,
          tip: btn.tip,
        },
        () => {
          this.$emit("addBtnClick", data);
        }
      );
    },
    // 全屏显示
    handleScreen() {
      const el = document.getElementById("player_wrap");
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (isFull) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        (el.requestFullscreen && el.requestFullscreen()) ||
          (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
          (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
          (el.msRequestFullscreen && el.msRequestFullscreen());
      }
    },
    // 切换窗口
    handleChangeScreen(num) {
      this.activeWnd = 1;
      this.windowNumber = num;
      this.showScreenTip = false;
    },
    // 选中窗口
    handleClickWnd(info) {
      this.activeWnd = info;
      this.$emit(
        "handleClickWnd",
        this.deviceRecord["wnd_" + info],
        this.playRecord["wnd_" + info]
      );
    },
    // 双击放大窗口
    handleDblClickWnd(info) {
      this.screenWnd = info = this.screenWnd ? 0 : info;
    },
    // 当前激活的窗口高亮
    hasActive(wnd) {
      return this.activeWnd === wnd ? "player-box__item--active" : "";
    },
    // 当前激活的窗口放大
    hasScreen(wnd) {
      return this.screenWnd === wnd ? "full-screen" : "";
    },

    // 视频直播
    async handlePlayLive(deviceInfo, checkIndex, btn) {
      console.log("设备信息", checkIndex, deviceInfo);
      let that = this;
      let index = checkIndex || (await this.handleGetFreeWnd());
      let wndKey = "wnd_" + index;
      if (!that.playRecord || !that.playRecord[wndKey] || !that.playRecord[wndKey].id) {
        that.$message.warning("插件正在加载中,请稍后再试");
        return;
      }
      this.activeWnd = index;
      that.deviceRecord[wndKey] = { ...deviceInfo };
      imosSdk.playLive(
        that.playRecord[wndKey].id,
        deviceInfo.thirdCameraId,
        deviceInfo.name,
        (res) => {
          if (that.isAddBtn) {
            that.addBtn(that.playRecord[wndKey].id, that.deviceRecord[wndKey], btn);
          }
          that.$emit("handleLiveSuccess", {
            ...deviceInfo,
          });
          that.isShowRightTitle && that.handleAddWndTitle(wndKey, deviceInfo); //添加标题
          that.handleLiveVideoBtn(wndKey, deviceInfo); //添加关闭按钮,录像按钮
        },
        1
      );
      // console.log(this.playRecord, this.deviceRecord, "===playLive");
    },
    // 视频录像
    async handlePlayVideo(deviceInfo, checkIndex) {
      this.screenWnd = 0;
      console.log("录像设备信息", deviceInfo);
      let that = this;
      let index = checkIndex || (await this.handleGetFreeWnd());
      this.activeWnd = index;
      let wndKey = "wnd_" + index;
      that.deviceRecord[wndKey] = { ...deviceInfo, videoType: "back" }; //存储设备信息
      // 播放录像
      imosSdk.playRecord(
        that.playRecord[wndKey].id, //窗口id
        deviceInfo.thirdCameraId, //摄像机编码
        deviceInfo.name, //标题名称
        deviceInfo.startTime, //new Date("2022-11-25 10:00:00"),
        deviceInfo.endTime, //new Date("2022-11-27 10:00:00"),
        (res) => {
          if (res.ErrCode != 0 && res.ErrCode != -1) {
            this.$message.error(res.ErrMsg || "视频获取失败，请稍后再试");
          }
        }
      );
    },
    // 监听关闭事件
    addEventClick(wndKey) {
      let that = this;
      let closeDom = document
        .querySelector(`.${wndKey}`)
        .querySelector(".imosVideo-icon-close");
      closeDom &&
        closeDom.addEventListener(
          "click",
          (e) => {
            that.handleStopVideo(wndKey);
          },
          true
        );
    },
    // 直播窗口自定义按钮
    handleLiveVideoBtn(wndKey, deviceInfo) {
      let that = this;
      that.hiddenVideoBtn({
        wndKey: wndKey,
        videoItem: {
          type: 4,
          btnId: ["close"],
        },
      });
      // 关闭
      that.addVideoBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoClose",
          className: "videoClose videoBtn",
          iconUrl: "/images/theme/newDark/play-box/关闭.png", //路径基于public
          tip: "关闭",
        },
        clickFunc: that.handleStopVideo,
      });
      //即时回放btn
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoBack",
          className: "videoBack videoBtn",
          tip: "即时回放",
        },
        clickFunc: that.handleOpenVideoDialog,
      });
      //上报告警
      that.addBottomBtn({
        wndKey: wndKey,
        buttonInfo: {
          id: "videoAlarm",
          className: "videoAlarm videoBtn",
          tip: "上报告警",
        },
        clickFunc: that.handleAddAlarm,
      });
    },
    // 添加控制栏按钮
    addBottomBtn(option) {
      let that = this;
      imosSdk.addBottomBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.buttonInfo,
        (res) => {
          option.clickFunc(option.wndKey);
        }
      );
    },
    // 添加窗口标题
    handleAddWndTitle(wndKey, deviceInfo) {
      // 通过添加伪元素显示标题
      let activeDom = document.querySelector("." + wndKey);
      activeDom.setAttribute(
        "style",
        "--deviceName:" + "'" + deviceInfo.rightTitle + "'"
      );
    },
    //添加btn
    addVideoBtn(option) {
      let that = this;
      imosSdk.addTitleBtn(
        that.playRecord[option.wndKey].id, //窗口id
        option.buttonInfo,
        (res) => {
          option.clickFunc(option.wndKey);
        }
      );
    },

    // 上报告警
    handleAddAlarm(wndKey) {
      this.$app.AppInstance.handleMiniReportAlarm(
        {
          name: this.deviceRecord[wndKey].name, //摄像机名称
          thirdCameraId: this.deviceRecord[wndKey].thirdCameraId, //摄像机id
          playRecordId: this.playRecord[wndKey].id, //窗口id
        },
        {
          right: "16px",
        }
      );
    },
    // 即时回放，默认回放前5h
    handleOpenVideoDialog(wndKey) {
      this.$app.AppInstance.handleMiniPlayDialog({
        playType: "back",
        playTitle: this.deviceRecord[wndKey].name, //摄像机名称
        playId: this.deviceRecord[wndKey].thirdCameraId, //摄像机id
        startTime: new Date().getTime() - 1000 * 60 * 60 * 5, //如果没有时间默认最新一分钟
        endTime: new Date().getTime(),
      });
    },
    // 关闭所有视频
    handleStopAllVideo() {
      // console.log(this.playRecord, this.deviceRecord, "===playRecord");
      for (let key in this.playRecord) {
        this.deviceRecord[key] && this.handleStopVideo(key);
      }
    },
    // 关闭单个视频
    handleStopVideo(wndKey) {
      let that = this;
      let index = wndKey.split("_")[1];
      let iframeId = this.playRecord[wndKey].id;
      //清除摄像机名称
      if (this.isShowRightTitle) {
        let parentClass = "." + this.playBoxClass;
        let domClass = parentClass + " ." + wndKey;
        console.log(domClass);
        let activeDom = document.querySelector(domClass);
        console.log(activeDom);
        if (index <= this.windowNumber) {
          activeDom.setAttribute("style", "--deviceName:" + "");
        } else {
          activeDom.setAttribute("style", "display:" + "none");
        }
      }

      imosSdk.playStop(iframeId, function (e) {
        that.$emit("handlePlayLiveClose", {
          ...that.deviceRecord[wndKey],
        });
        that.deviceRecord[wndKey] && delete that.deviceRecord[wndKey];
      });
    },
    // 计算适合当前播放器的窗口数量
    setWndNumber(i) {
      // 默认9窗口,如果窗口位置超出当前显示的窗口,则依次显示13,16,25窗口
      if (i <= this.windowNumber) {
        return;
      }
      if (i > 1 && i <= 4) {
        this.windowNumber = 4;
      }
      if (i > 4 && i <= 6) {
        this.windowNumber = 6;
      }
      if (i > 6 && i <= 9) {
        this.windowNumber = 9;
      }
      if (i > 9 && i <= 13) {
        this.windowNumber = 13;
      }
      if (i > 13 && i <= 16) {
        this.windowNumber = 16;
      }
      if (i > 16 && i <= 25) {
        this.windowNumber = 25;
      }
    },
    // 获取空余窗口
    handleGetFreeWnd(wnd = this.activeWnd) {
      return new Promise((resolve) => {
        // wnd默认为1，依次递增
        if (this.screenWnd > 0) {
          // 如果窗口放大状态,替换当前放大的窗口
          this.deviceRecord[`wnd_${this.screenWnd}`] &&
            this.handleStopVideo("wnd_" + this.screenWnd);
          setTimeout(() => {
            resolve(this.screenWnd);
          }, 200);
          return;
        }

        const _activeKey = `wnd_${wnd}`;
        // 当前选中窗口是否有视频播放
        if (!this.deviceRecord[_activeKey]) {
          resolve(wnd);
          return;
        } else {
          // 先满足空余窗口的播放,在满足指定窗口的播放
          for (let i = 1; i <= this.maxWnd; i++) {
            let maskEle = document
              .querySelector(`.wnd_${i}`)
              .querySelector(".imosVideo-mask");
            if (!this.deviceRecord[`wnd_${i}`] && maskEle) {
              this.setWndNumber(i);
              resolve(i);
              return;
            } else {
              // 最后一轮:如果没有空余窗口,则替换当前选中的窗口
              if (i == this.maxWnd) {
                this.handleStopVideo("wnd_1");
                setTimeout(() => {
                  resolve(1);
                }, 200);
              }
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .imosSdk-video {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
}
:deep .imosVideo-title-icon {
  display: flex;
  top: 0;
  flex-direction: row-reverse;
}

:deep .videoAlarm {
  background: url("/images/theme/newDark/play-box/上报告警.png") center no-repeat !important;
}
:deep .videoBack {
  background: url("/images/theme/newDark/play-box/即时回放.png") center no-repeat !important;
}
:deep .detailBtn {
  background: url("/images/theme/newDark/play-box/xiangqing.png") center no-repeat !important;
}

:deep .imosVideo-mask {
  background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat !important;
  background-size: 100%;
}

:deep .imosVideo-playPauseIcon {
  display: none !important;
}
.player_wrap {
  flex: 1;
  height: 100%;
  position: relative;
  // margin-left: 6px;
}

.player-box {
  width: 100%;
  height: 100%;
  // padding: 12px;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  @include set_theme_color(background-color, left-menu-bg-color);
  .full-screen {
    width: calc(100% - 0px) !important;
    height: calc(100% - 0px) !important;
    position: absolute;
    left: 0px !important;
    top: 0px !important;
    z-index: 3;
  }

  &--layout6 {
    .player-box__item {
      width: calc(100% / 3 - 1px);
      height: calc(100% / 3 - 2px);
    }
    .player-box__item:first-child {
      width: calc(100% / 3 * 2 - 0.5px);
      height: calc(100% / 3 * 2 - 3px);
    }

    .player-box__item:nth-child(3) {
      position: absolute;
      top: calc(100% / 3 + 0px);
      right: 0px;
      height: calc(100% / 3 - 3px);
      width: calc(100% / 3 - 1px);
    }
  }

  &--layout13 {
    .player-box__item {
      width: calc(100% / 4 - 1px);
      height: calc(100% / 4 - 2px);
    }

    .player-box__item:nth-child(6) {
      height: calc(100% / 4 - 2px);
      width: calc(100% / 4 - 1px);
      position: absolute;
      top: 50%;
    }

    .player-box__item:nth-child(7) {
      height: calc(100% / 2 - 1px);
      width: calc(100% / 2 - 2px);
    }

    .player-box__item:nth-child(9) {
      position: absolute;
      top: 50%;
      right: 0px;
      height: calc(100% / 4 - 2px);
      width: calc(100% / 4 - 1px);
    }
  }

  &__item {
    width: calc(100% / var(--layoutType) - 1px);
    height: calc(100% / var(--layoutType) - 2px);
    background: #3a3a3a url("/images/theme/newDark/default.png") center no-repeat;
    // background-size: 100% 100%;
    border: 1px solid #181f2e;
    transition: all 0s ease-in;
    position: relative;

    &--active {
      border-color: royalblue;
    }
    &--catch {
      &::before {
        content: "REC";
        position: absolute;
        z-index: 2;
        width: 36px;
        height: 18px;
        line-height: 18px;
        border-radius: 50%;
        top: 31px;
        font-size: 12px;
        text-align: center;
        right: 20px;
        display: block;
        background: red;
        animation: rec 0.5s infinite alternate;
      }
    }
    &:hover {
      &::after {
        display: none;
      }
    }
    &::after {
      content: var(--deviceName);
      position: absolute;
      z-index: 2;
      top: 10px;
      right: 2px;
      padding: 1px 11px;
      border-radius: 3px;
      font-size: 15px;
      display: block;
    }
  }
  @keyframes rec {
    0% {
      opacity: 0.8;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
